import React, { useEffect, useRef, useState } from "react";
import "../../../Static/priceinfo.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAllCutReturnInlist,
  selectCuttingDatalist,
} from "../../Selectors/Master/ItemSelectors";
import ReactToPrint from "react-to-print";
import { Grid, Paper } from "@mui/material";
import {
  fetchAllCutReturnInhosuelist,
  fetchCuttingList,
} from "../../../Store/PHPSlice/Cutting/cuttingApi";
import PreviewIcon from "@mui/icons-material/Preview";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;

const CuttingReturnClothInfo = () => {
  const [formData, setFormData] = useState({
    dt: "",
    empNm: "",
    empType: "",
    cutId: "",
    cutMemo: "",
    reMemo: "",
    itemId: "",
    itemNm: "",
    reQty: "",
    totQty: "",
    gMtr: "",
    actAvg: "",
    mcloth: "",
    mclothNm: "",
    m1cloth: "",
    m1clothNm: "",
    m2cloth: "",
    m2clothNm: "",
    m3cloth: "",
    m3clothNm: "",
    soId: "",
    sono: "",
    partyId: "",
    partyNm: "",
    schlNm: "",
    schlId: "",
    mavg: "0",
    m1avg: "0",
    m2avg: "0",
    m3avg: "0",
    instruction: "",
    userId: "1",
  });
  const { Id } = useParams();
  const dispatch = useDispatch();
  const returnInfolist = useSelector(selectAllCutReturnInlist);
  const [clothDetails, setClothDetails] = useState([]);

  const cutdatalist = useSelector(selectCuttingDatalist);

  const isDesktop = useMediaQuery("(min-width:768px)");
  const componentRef = useRef(); // Ref for the component to be printed
  useEffect(() => {
    dispatch(fetchAllCutReturnInhosuelist(Id));
    dispatch(fetchCuttingList(Id));
  }, [Id]);
  console.log(returnInfolist);
  useEffect(() => {
    if (returnInfolist.data) {
      const item = returnInfolist.data;
      setFormData((prev) => ({
        ...prev,
        dt: item.dt || "",
        empId: item.empId || "",
        empNm: item.empNm || "",
        empType: item.empType || "",
        itemId: item.itemId || "",
        itemNm: item.itemNm || "",
        reQty: item.totReturnqty || "",
        totQty: item.totIssqty || "",
        soId: item.soId || "",
        sono: item.sono || "",
        gMtr: item.mgmtr || "",
        cutMemo: item.ctMemo || "",
        mcloth: item.mcloth || "",
        mclothNm: item.mclothNm || "",
        m1cloth: item.m1cloth || "",
        m1clothNm: item.m1clothNm || "",
        m2cloth: item.m2cloth || "",
        m2clothNm: item.m2clothNm || "",
        m3cloth: item.m3cloth || "",
        m3clothNm: item.m3clothNm || "",
        instruction: item.instruction,
      }));
    }
  }, [returnInfolist]);

  var compData = Array.isArray(returnInfolist?.data2)
    ? returnInfolist?.data2?.map((item, index) => ({
        serialNumber: index + 1,
        dt: item.dt,
        ctId: formData.cutId,
        retMemo: item.ctreMemo,
        reQty: item.reqty,
      }))
    : [];
  useEffect(() => {
    getClothDetails();
  }, [Id]);
const getReturnTypeColor = (type) => {
  switch (type) {
    case "cloth_return":
      return "#28a745"; // Green

    case "carry_forward":
      return "#ff9800"; // Orange

    case "settlement":
      return "#dc3545"; // Red

    default:
      return "#000";
  }
};
const getClothDetails = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}?apicall=getRTCuttingClothInfo&ctId=${Id}`
    );

    const clothRows =
      response.data?.data?.map((item) => ({
        type: item.clothType,
        clothId: item.clothId,
        clothName: item.clothNm,
        gmtr: item.givenMtr,
        req: item.requiredMtr,
        used: item.usedMtr,
        returnMtr: item.balanceMtr,
        returnType: item.returnType,
        deductAmt: item.deductAmt,
      })) || [];

    setClothDetails(clothRows);
  } catch (error) {
    console.error("Error fetching cloth details:", error);
  }
};

  const handleClothChange = (index, field, value) => {
    const updated = [...clothDetails];

    updated[index][field] = value;

    if (field === "returnMtr" || field === "rate" || field === "returnType") {
      if (updated[index].returnType === "settlement") {
        updated[index].deductAmt =
          Number(updated[index].returnMtr || 0) *
          Number(updated[index].rate || 0);
      } else {
        updated[index].deductAmt = 0;
      }
    }

    setClothDetails(updated);
  };
  const tableContainerStyle = {
    marginLeft: isDesktop ? "5%" : "0%",
    width: isDesktop ? "90%" : "100%",
    overflow: "hidden",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  };

  const webkitScrollbarStyle = {
    overflowX: "auto", // Ensure the x-axis scrollbar is visible
    overflowY: "hidden", // Hide the y-axis scrollbar
    WebkitOverflowScrolling: "touch", // Enable smooth scrolling on iOS
  };
  const handleSubmit = async () => {
    try {
      const saveData = {
        ctId: Id,
        userId: formData.userId,
        clothDetails: clothDetails,
      };

      const response = await axios.post(
        `${baseUrl}?apicall=saveCuttingClothReturn`,
        saveData,
      );
//console.log("save",response.data);
      if (response.data.success) {
        alert("Saved Successfully");
      } else {
        alert(response.data.msg);
      }
    } catch (error) {
      console.error(error);
      alert("Error Saving Data");
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Paper style={{ padding: "3vh", margin: "0" }}>
          <div style={{ margin: "1% 0%", width: "100%" }} ref={componentRef}>
            <h3 className="centered-heading">Cloth Returned Info</h3>
            <div className="dashed-line"></div>

            <table style={{ margin: "1% 5%", fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td style={{ width: "200px" }}>Date</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.dt}
                  </td>

                  <td style={{ width: "200px" }}>Cutting Memo No.</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.cutMemo}
                  </td>
                </tr>

                {formData.soId !== "0" && (
                  <>
                    <tr>
                      <td style={{ width: "200px" }}>Sale Order No.</td>
                      <td>:</td>
                      <td
                        style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                        className="dark-color"
                      >
                        {formData.sono}
                      </td>
                      <td style={{ width: "200px" }}>Party</td>
                      <td>:</td>
                      <td
                        style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                        className="dark-color"
                      >
                        {formData.partyNm}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ width: "200px" }}>School Name</td>
                      <td>:</td>
                      <td
                        style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                        className="dark-color"
                      >
                        {formData.schlNm}
                      </td>
                    </tr>
                  </>
                )}
                <tr>
                  <td style={{ width: "200px" }}>Master</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.empNm}
                  </td>
                  <td style={{ width: "200px" }}>Item</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.itemNm}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Total Issue Qty.</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.totQty}
                  </td>
                  <td style={{ width: "200px" }}>Total Return Qty.</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.reQty}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "200px" }}>Cutting Instruction</td>
                  <td>:</td>
                  <td
                    style={{ width: "30vw", padding: " 0.2%  1.5%" }}
                    className="dark-color"
                  >
                    {formData.instruction}
                  </td>
                </tr>
              </tbody>
            </table>

            <h4 className="centered-heading">Cloth Returnd Details</h4>
            <TableContainer
              style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Sr.No.
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Type of Cloth
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Cloth Name
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Given Mtr
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Reqiured Mtr
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Used Mtr
                    </TableCell>
                   
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Cloth Return Mtr
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Return Type
                    </TableCell>
                    <TableCell
                      sx={{ p: 1, border: "1px solid #000" }}
                      align="center"
                      className="tbl-row"
                    >
                      Cloth Return Amt
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {clothDetails.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {row.type}
                      </TableCell>

                      <TableCell sx={{ border: "1px solid #000" }}>
                        {row.clothName}
                      </TableCell>

                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {row.gmtr}
                      </TableCell>

                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {row.req}
                      </TableCell>

                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {row.used}
                      </TableCell>

                    

                      <TableCell
                        sx={{ border: "1px solid #000" }}
                        align="center"
                      >
                        {row.returnMtr}
                      </TableCell>
                     <TableCell
  sx={{
    border: "1px solid #000",
    color: getReturnTypeColor(row.returnType),
    fontWeight: "bold",
    textTransform: "capitalize",
  }}
>
  {row.returnType.replace("_", " ")}
</TableCell>
                     <TableCell
  sx={{
    border: "1px solid #000",
    color: getReturnTypeColor(row.returnType),
    fontWeight: "bold",
  }}
>
  ₹ {row.deductAmt}
</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* <div style={{ marginTop: "20px", textAlign: "center" }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Save Cloth Return
            </Button>
          </div> */}
          {/* <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div> */}
        </Paper>
      </Grid>
    </>
  );
};

export default CuttingReturnClothInfo;
